const getSelectedBlockKeys = (content, startKey, endKey) => {
    const keys = [];
    let inRange = false;

    content.getBlockMap().forEach((_, key) => {
        if (key === startKey) inRange = true;
        if (inRange) keys.push(key);
        if (key === endKey) inRange = false;
    });

    return keys;
};

const getEntityRangeForOffset = (block, offset, entityKey) => {
    const blockLength = block.getLength();
    let start = offset;
    let end = offset + 1;

    while (start > 0 && block.getEntityAt(start - 1) === entityKey) {
        start -= 1;
    }

    while (end < blockLength && block.getEntityAt(end) === entityKey) {
        end += 1;
    }

    return { start, end };
};

export const getTouchedLinkRanges = (editorState) => {
    const selection = editorState.getSelection();
    const content = editorState.getCurrentContent();
    const startKey = selection.getStartKey();
    const endKey = selection.getEndKey();
    const blockKeys = getSelectedBlockKeys(content, startKey, endKey);
    const ranges = [];
    const seen = new Set();

    blockKeys.forEach((blockKey) => {
        const block = content.getBlockForKey(blockKey);
        const blockLength = block.getLength();
        const isStartBlock = blockKey === startKey;
        const isEndBlock = blockKey === endKey;

        let from = isStartBlock ? selection.getStartOffset() : 0;
        let to = isEndBlock ? selection.getEndOffset() : blockLength;

        if (selection.isCollapsed()) {
            from = selection.getStartOffset();
            to = from;
        }

        if (selection.isCollapsed()) {
            const offset = Math.min(from, Math.max(0, blockLength - 1));
            const leftOffset = Math.max(0, from - 1);
            const probeOffsets = [offset, leftOffset];

            probeOffsets.forEach((probeOffset) => {
                if (probeOffset >= blockLength) return;
                const entityKey = block.getEntityAt(probeOffset);
                if (!entityKey) return;
                if (content.getEntity(entityKey).getType() !== "LINK") return;

                const { start, end } = getEntityRangeForOffset(block, probeOffset, entityKey);
                const rangeKey = `${blockKey}:${start}:${end}`;
                if (seen.has(rangeKey)) return;

                seen.add(rangeKey);
                ranges.push({ blockKey, start, end });
            });

            return;
        }

        for (let i = from; i < to; i += 1) {
            const entityKey = block.getEntityAt(i);
            if (!entityKey) continue;
            if (content.getEntity(entityKey).getType() !== "LINK") continue;

            const { start, end } = getEntityRangeForOffset(block, i, entityKey);
            const rangeKey = `${blockKey}:${start}:${end}`;
            if (seen.has(rangeKey)) continue;

            seen.add(rangeKey);
            ranges.push({ blockKey, start, end });
        }
    });

    return ranges;
};
